import Yaafloop from "yaafloop"

const timer = {"s": 0, "ms": 0}

const loop = new Yaafloop(function(delta) {
    // timer.time += delta.s
    timer.s += delta.s
    timer.ms += delta.ms
})

window.timer = timer

export default timer
